import { type IconId, PixelIcon } from "@/components/PixelIcon/PixelIcon";
import css from "./Card.module.scss";

type Props = {
  title: React.ReactNode;
  level?: 2 | 3;
  icon?: IconId;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
};

export function Card({ title, level = 2, icon, subtitle, children }: Props) {
  const Element = `h${level}` as const;

  return (
    <div className={css.card}>
      <Element className={css.title}>
        {icon && <PixelIcon icon={icon} size={24} alt="" />}
        {title}
      </Element>

      {subtitle && <p className={css.subtitle}>{subtitle}</p>}

      <div className={css.body}>{children}</div>
    </div>
  );
}
